// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-row {
  height: 100%;
}

.container {
  display: inline-block;
  position: relative;
  overflow: hidden;
  margin: auto;
}

.backgroundCanvas {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  max-height: 100%;
}

.signaturePad {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  max-height: 100%;
}

ion-fab {
  position: relative;
}

.secondary-toolbar div {
  display: flex;
  flex-wrap: wrap;
}
.secondary-toolbar .selected {
  border-bottom: 4px solid var(--ion-color-primary);
  padding-bottom: 0;
}
.secondary-toolbar .separator {
  margin: 10px 5px;
  padding: 0;
  border-left: thin solid var(--ion-color-medium-light);
}

.template {
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 5%;
}

.video, .captureCanvas {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  max-height: 100%;
}

.full-height {
  height: 100%;
}

.no-overflow {
  overflow: hidden;
}

.one-third-height {
  height: 33%;
}

.with-left-border {
  border-left: solid thin #EBEBEB;
}

ion-button {
  --color: var(--ion-color-primary-contrast);
  --background: var(--ion-color-primary-contrast);
  --background-hover: var(--ion-color-primary-contrast);
  --background-activated: var(--ion-color-primary-contrast);
  --background-focused: var(--ion-color-primary-contrast);
}

.button1 {
  position: absolute;
  left: 20%;
  bottom: 0;
  transform: translate(-50%, 0);
}

.button2 {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
}

.button3 {
  position: absolute;
  left: 80%;
  bottom: 0;
  transform: translate(-50%, 0);
}`, "",{"version":3,"sources":["webpack://./src/gyzmo-commons/modals/draw/draw.modal.scss","webpack://./src/gyzmo-commons/modals/browser-camera/browserCamera.modal.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,kBAAA;ACCJ;;ADGI;EACI,aAAA;EACA,eAAA;ACAR;ADGI;EACI,iDAAA;EACA,iBAAA;ACDR;ADII;EACI,gBAAA;EACA,UAAA;EACA,qDAAA;ACFR;;AAzCA;EACI,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA4CJ;;AAzCA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;AA4CJ;;AAzCA;EACI,YAAA;AA4CJ;;AAzCA;EACI,gBAAA;AA4CJ;;AAzCA;EACI,WAAA;AA4CJ;;AAzCA;EACI,+BAAA;AA4CJ;;AAzCA;EACI,0CAAA;EAEA,+CAAA;EACA,qDAAA;EACA,yDAAA;EACA,uDAAA;AA2CJ;;AAxCA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;AA2CJ;;AAxCA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;AA2CJ;;AAxCA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;AA2CJ","sourcesContent":[".container-row {\n    height: 100%;\n}\n\n.container {\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    margin: auto;\n}\n\n.backgroundCanvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.signaturePad {\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 100%;\n    max-height: 100%;\n}\n\nion-fab {\n    position: relative;\n}\n\n.secondary-toolbar {\n    div {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .selected {\n        border-bottom: 4px solid var(--ion-color-primary);\n        padding-bottom: 0;\n    }\n\n    .separator {\n        margin: 10px 5px;\n        padding: 0;\n        border-left: thin solid var(--ion-color-medium-light);\n    }\n}\n","@import '../draw/draw.modal';\n\n.template {\n    background: rgba(255, 255, 255, 0.1);\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    padding: 5%;\n}\n\n.video, .captureCanvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.full-height {\n    height: 100%;\n}\n\n.no-overflow {\n    overflow: hidden;\n}\n\n.one-third-height {\n    height: 33%;\n}\n\n.with-left-border {\n    border-left: solid thin #EBEBEB;\n}\n\nion-button {\n    --color: var(--ion-color-primary-contrast);\n\n    --background: var(--ion-color-primary-contrast);\n    --background-hover: var(--ion-color-primary-contrast);\n    --background-activated: var(--ion-color-primary-contrast);\n    --background-focused: var(--ion-color-primary-contrast);\n}\n\n.button1 {\n    position: absolute;\n    left: 20%;\n    bottom: 0;\n    transform: translate(-50%, 0);\n}\n\n.button2 {\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    transform: translate(-50%, 0);\n}\n\n.button3 {\n    position: absolute;\n    left: 80%;\n    bottom: 0;\n    transform: translate(-50%, 0);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
